import { fetchBasicUrlPostJson, fetchBasicJsonPost } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicUrlPostJson('/Diagnosis/GetPatientDiagnoses', {
            asGridData: true,
            data: parameters,
            signal
        });
    },
};
